import classNames from 'classnames';

import styles from './customButton.module.scss';
import DotsLoading from 'components/loadings/dotsLoading';
interface ICustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  disabled?: boolean;
  outLet?: boolean;
  isLoading?: boolean;
  noBorder?: boolean;
}
const CustomButton = ({
  title,
  disabled,
  outLet,
  isLoading,
  noBorder,
  ...props
}: ICustomButtonProps) => {
  return (
    <>
      <button
        {...props}
        className={classNames(
          noBorder
            ? styles['btn-custom-no-border']
            : outLet
            ? styles['btn-custom-outlet']
            : styles['btn-custom'],
          props.className,
        )}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <DotsLoading extraStyleCircle="!bg-white !text-wnite" />
        ) : title ? (
          title
        ) : (
          props.children
        )}
      </button>
    </>
  );
};

export default CustomButton;
